import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFarmsData } from '../../store/farms/farms.actions';
import { selectAllFarms } from '../../store/extra/extra.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import FarmsTable from '../../components/shared/tables/FarmsTable';
import { Title } from '../../components/shared';

const ArchivedFarmsPage = () => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);
  const allFarms = useSelector(selectAllFarms);

  const archivedFarms = allFarms.filter(
    farm => !farm.is_active || farm.lines.some(line => !line.is_active),
  );

  useEffect(() => {
    dispatch(loadFarmsData());
  }, [dispatch]);

  return (
    <div className='bg-secondary min-height'>
      <div className='container'>
        <div className='queued-page-header d-flex justify-between align-center'>
          <Title size={5} color='black' align='default' fontWeight={700}>
            {translate(lang, 'Archived Farms')}
          </Title>
        </div>
        <div className='w-100 pb-32'>
          <FarmsTable farmsData={archivedFarms} isActive={false} />
        </div>
      </div>
    </div>
  );
};

export default ArchivedFarmsPage;
